export const cleanupPaymentMethods = () => {
  const scriptsToRemove = [
    'script[src="https://hms.transactiongateway.com/token/Collect.js"]',
    'script[src*="apple-pay-sdk.js"]',
  ];

  scriptsToRemove.forEach((selector) => {
    const script = document.querySelector(selector);
    if (script) script.remove();
  });

  const existingTokenizationScript = document.querySelector(
    `script[src="https://hms.transactiongateway.com/token/Collect.js"]`
  );
  if (existingTokenizationScript) {
    existingTokenizationScript.parentNode.removeChild(
      existingTokenizationScript
    );
  }

  const existingScript = document.querySelector(
    `script[src="https://hms.transactiongateway.com/token/Collect.js"]`
  );

  if (existingScript) {
    return Promise.resolve();
  }

  const elementsToRemove = [
    "apple-spinner",
    "[data-apple-pay]",
    ".google-pay-button",
    "#applepaybutton",
  ];

  elementsToRemove.forEach((selector) => {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
      if (element.innerHTML) element.innerHTML = "";
      if (element.remove) element.remove();
    });
  });

  try {
    const originalDefine = customElements.define;
    customElements.define = function (name, constructor, options) {
      if (customElements.get(name)) {
        console.warn(
          `Custom element "${name}" is already defined, skipping registration.`
        );
        return;
      }
      return originalDefine.call(customElements, name, constructor, options);
    };
  } catch (error) {
    console.warn("Could not override customElements.define:", error);
  }
};

export const loadCardScript = (tokenizationKey) => {
  if (!tokenizationKey) {
    return Promise.reject(new Error("Tokenization key is required"));
  }

  if (typeof tokenizationKey !== 'string' || tokenizationKey.trim() === '') {
    return Promise.reject(new Error("Tokenization key must be a non-empty string"));
  }

  if (!tokenizationKey.match(/^.{6}-.{6}-.{6}-.{6}$/g) &&
  !tokenizationKey.match(/^checkout_public_.{32}$/g)) {
    return Promise.reject(new Error("Invalid tokenization key format"));
  }

  cleanupPaymentMethods();

  return new Promise((resolve, reject) => {
    const tokenizationScript = document.createElement("script");
    tokenizationScript.src =
      "https://hms.transactiongateway.com/token/Collect.js";
    tokenizationScript.dataset.tokenizationKey = tokenizationKey;
    tokenizationScript.dataset.styleSniffer = "true";

    tokenizationScript.onerror = (error) => {
      console.error("Error loading Collect.js:", error);
      reject(new Error("Failed to load the tokenization script"));
    };

    tokenizationScript.onload = () => {
      const originalAppendChild = document.head.appendChild;
      const originalDefine = customElements.define;

      customElements.define = function (name, constructor, options) {
        if (customElements.get(name)) {
          console.warn(
            `Custom element "${name}" is already defined, skipping registration.`
          );
          return;
        }
        return originalDefine.call(customElements, name, constructor, options);
      };

      document.head.appendChild = function (element) {
        if (
          element.tagName === "SCRIPT" &&
          element.src.includes("apple-pay-sdk.js") &&
          document.querySelector('script[src*="apple-pay-sdk.js"]')
        ) {
          console.warn("Prevented duplicate Apple Pay SDK script injection.");
          return element;
        }
        return originalAppendChild.call(document.head, element);
      };
      resolve();
    };

    document.head.appendChild(tokenizationScript);
  });
};

export const loadApplePayScript = (
  tokenizationKey,
  paymentFormik,
  isDonationMode
) => {
  if (!tokenizationKey) {
    return Promise.reject(new Error("Tokenization key is required"));
  }
  if (typeof tokenizationKey !== 'string' || tokenizationKey.trim() === '') {
    return Promise.reject(new Error("Tokenization key must be a non-empty string"));
  }
  // Clean up any existing scripts first
  cleanupPaymentMethods();

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://hms.transactiongateway.com/token/Collect.js";
    script.dataset.tokenizationKey = tokenizationKey;
    script.dataset.variant = "inline";
    script.dataset.country = "US";
    script.dataset.price = paymentFormik?.values?.amount || "1.00";
    script.dataset.currency = "USD";
    script.dataset.fieldApplePayType = isDonationMode ? "donate" : "buy";

    script.dataset.timeoutCallback = () => {
      window.location.reload();
      return;
    };

    script.onload = () => {
      resolve();
    };

    script.onerror = () => {
      reject(new Error("Failed to load Apple Pay script"));
    };

    try {
      document.head.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};

export const loadGooglePayScript = (tokenizationKey, paymentFormik) => {
  if (!tokenizationKey) {
    return Promise.reject(new Error("Tokenization key is required"));
  }

  if (typeof tokenizationKey !== 'string' || tokenizationKey.trim() === '') {
    return Promise.reject(new Error("Tokenization key must be a non-empty string"));
  }

  if (!tokenizationKey.match(/^.{6}-.{6}-.{6}-.{6}$/g) &&
  !tokenizationKey.match(/^checkout_public_.{32}$/g)) {
    return Promise.reject(new Error("Invalid tokenization key format"));
  }

  // Clean up any existing scripts first
  cleanupPaymentMethods();

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://hms.transactiongateway.com/token/Collect.js";
    script.dataset.tokenizationKey = tokenizationKey;
    script.dataset.variant = "inline";
    script.dataset.fieldGooglePaySelector = ".google-pay-button";
    script.dataset.fieldGooglePayShippingAddressRequired = "true";
    script.dataset.fieldGooglePayShippingAddressParametersPhoneNumberRequired =
      "true";
    script.dataset.fieldGooglePayShippingAddressParametersAllowedCountryCodes =
      "US,CA";
    script.dataset.fieldGooglePayBillingAddressRequired = "true";
    script.dataset.fieldGooglePayBillingAddressParametersPhoneNumberRequired =
      "true";
    script.dataset.fieldGooglePayBillingAddressParametersFormat = "MIN";
    script.dataset.country = "US";
    script.dataset.price = paymentFormik?.values?.amount || "1.00";
    script.dataset.currency = "USD";

    script.dataset.timeoutCallback = () => {
      window.location.reload();
      return;
    };

    script.onload = () => {
      resolve();
    };

    script.onerror = () => {
      reject(new Error("Failed to load Google Pay script"));
    };

    try {
      document.head.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};
